$(document).ready(function () {
	
    $("img.has-tooltip").tooltip({
        title: function () {
            return $(this).attr("alt");
        },
        placement: "auto"
    });

    $("a.has-tooltip").tooltip({
        placement: "auto"
	});

	$('h1', '.header__phone', '.header__phone-2', '.header__email', '.featured-categories__title', '.banner__text').attr("data-text", function () {
		return $(this).text();
	});	
});

